import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _decodeInstanceRequest = {};
var _decodeInstanceResponse = {};
function resolveWixDevcenterIvV1InstanceVerificationUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/instance-verification',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/instance-verification',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/instance-verification',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Determines if the calling party is Wix and returns a decoded instance */
export function decodeInstance(payload) {
    var _a = serializer(_decodeInstanceRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_decodeInstanceResponse, {}).fromJSON;
    function __decodeInstance(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.iv.v1.instance',
            method: 'POST',
            methodFqn: 'wix.devcenter.iv.v1.InstanceVerification.DecodeInstance',
            url: resolveWixDevcenterIvV1InstanceVerificationUrl({
                protoPath: '/v1/decode-instance',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __decodeInstance.fromReq = fromReq;
    return __decodeInstance;
}
//# sourceMappingURL=http.impl.js.map